import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { bodyBold } from '../BodyBoldText';
import { mq } from '../../Theme';
import { StyledHeadingProps } from '../textUtils';

// @todo: Use heading sizes from theme config via `props.theme.fontSize`

const headingStyle = (resetSpacing?: boolean) =>
  resetSpacing &&
  css`
    margin: 0;
    padding: 0;
  `;

const Heading1 = styled.h1<StyledHeadingProps>`
  ${bodyBold}
  ${p => headingStyle(p.resetSpacing)}
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: ${({ theme }) => theme.fontWeight.heading};
  font-size: 1.875rem;
  line-height: 1.235em;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;

  ${mq('lg')} {
    font-size: ${({ theme }) => theme.fontSize.xl.size};
    line-height: 1.21em;
  }

  ${({ overrideStyles }) => overrideStyles}
`;

const Heading2 = styled.h2<StyledHeadingProps>`
  ${bodyBold}

  ${p => headingStyle(p.resetSpacing)}
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: ${({ theme }) => theme.fontWeight.heading};
  font-size: 1.625rem;
  line-height: 1.23em;
  margin-block: 0 ${p => (p.resetSpacing ? ' 0' : ' 1.75rem')};
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;

  ${mq('lg')} {
    font-size: ${({ theme }) => theme.fontSize.lg.size};
    line-height: 1.1875em;
  }

  ${({ overrideStyles }) => overrideStyles}
`;

const Heading3 = styled.h3<StyledHeadingProps>`
  ${bodyBold}

  ${p => headingStyle(p.resetSpacing)}
  font-family: ${({ theme }) => theme.fontFamily.alternate};
  font-weight: ${({ theme }) => theme.fontWeight.heading};
  font-size: 1.375rem;
  line-height: 1.18em;
  margin-block: 0 ${p => (p.resetSpacing ? ' 0' : ' 1.75rem')};
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;

  ${mq('lg')} {
    font-size: ${({ theme }) => theme.fontSize.md.size};
    line-height: 1.25em;
  }

  ${({ overrideStyles }) => overrideStyles}
`;

const Heading4 = styled.h4<StyledHeadingProps>`
  ${bodyBold}

  ${p => headingStyle(p.resetSpacing)}
  font-size: 1.125rem;
  line-height: 1.22em;
  margin-block: 0 ${p => (p.resetSpacing ? ' 0' : ' 1.75rem')};

  ${mq('lg')} {
    font-size: 1.25rem;
    line-height: 1.2em;
  }

  ${({ overrideStyles }) => overrideStyles}
`;

const Heading5 = styled.h5<StyledHeadingProps>`
  ${bodyBold}

  ${p => headingStyle(p.resetSpacing)}
  font-size: 1.125rem;
  line-height: 1.22em;

  ${mq('lg')} {
    font-size: 1.25rem;
    line-height: 1.2em;
  }

  ${({ overrideStyles }) => overrideStyles}
`;

const Heading6 = styled.h6<StyledHeadingProps>`
  ${bodyBold}

  ${p => headingStyle(p.resetSpacing)}
  font-size: 1.125rem;
  line-height: 1.22em;

  ${mq('lg')} {
    font-size: 1.25rem;
    line-height: 1.2em;
  }

  ${({ overrideStyles }) => overrideStyles}
`;

export { Heading1, Heading2, Heading3, Heading4, Heading5, Heading6 };
